import Link from 'next/link';
import { useMemo } from 'react';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

import { FOR_EMPLOYERS, FUNNEL, JOBS, PFLEGIA_TRUSTPILOT_FAQ_URL, PRAXIA_TRUSTPILOT_FAQ_URL } from '@shared/application/constants';
import { getBaseUrlByCurrentSourceDomain } from '@shared/utils/domain';

const LINK_CLASS_NAME = 'text-primary hover:underline';
const stopPropagation = (event: React.MouseEvent) => event.stopPropagation();

export const useFaqLinks = () => {
  const { sourceDomain, isPraxia } = useFlavorFromRoute();

  return useMemo(() => {
    const baseUrl = getBaseUrlByCurrentSourceDomain(sourceDomain);
    const trustpilotUrl = isPraxia ? PRAXIA_TRUSTPILOT_FAQ_URL : PFLEGIA_TRUSTPILOT_FAQ_URL;

    return {
      components: {
        registerLink: <Link onClick={stopPropagation} href={FUNNEL} className={LINK_CLASS_NAME} />,
        jobsLink: <Link onClick={stopPropagation} href={JOBS} className={LINK_CLASS_NAME} />,
        employersLink: <Link onClick={stopPropagation} href={FOR_EMPLOYERS} className={LINK_CLASS_NAME} />,
        trustpilotLink: <Link onClick={stopPropagation} target='_blank' href={trustpilotUrl} className={LINK_CLASS_NAME} />,
      },
      processedSchemaUrls: {
        registerLink: `${baseUrl}${FUNNEL}`,
        jobsLink: `${baseUrl}${JOBS}`,
        employersLink: `${baseUrl}${FOR_EMPLOYERS}`,
        trustpilotLink: trustpilotUrl,
      },
    };
  }, [sourceDomain, isPraxia]);
};
